// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2miOR","placeholdersHeader":"styles_placeholdersHeader__10k5h","editorStyle":"styles_editorStyle__3dH70","placeholdersBox":"styles_placeholdersBox__3WDPK"};